import { getOrderParties, GetOrderPartiesType } from 'graphql/parties/queries';
import { UseQueryOptions, useQuery } from 'react-query';

type Params = {
  orderId: string;
  kindsFilter?: string[];
  queryConfig?: UseQueryOptions<GetOrderPartiesType, Error, GetOrderPartiesType, any>;
};

export const useGetOrderParties = ({ orderId, kindsFilter, queryConfig }: Params) =>
  useQuery(
    ['order-parties', orderId, kindsFilter],
    async () => {
      const response = await getOrderParties(orderId);

      const sortedParties = [...response.getOrder.parties].sort((partyA, partyB) =>
        partyA.name.localeCompare(partyB.name)
      );

      let filteredParties = sortedParties;

      if (kindsFilter && kindsFilter.length) {
        filteredParties = sortedParties.filter((party) =>
          kindsFilter.some((kind) => party.kinds.includes(kind))
        );
      }

      return {
        ...response,
        getOrder: {
          ...response.getOrder,
          parties: filteredParties,
        },
      };
    },
    {
      ...queryConfig,
      enabled: !!orderId && queryConfig?.enabled !== false,
      refetchOnWindowFocus: false,
    }
  );
